<template>
<div>
<Exam/>

</div>
</template>

<script>
import Exam from "../../components/Applicant/Exam.vue";


export default {
  components: {
   Exam
  },beforeCreate: function() {
        document.body.className = 'iner';
    },
  created() {

  }
};
</script>

<style scoped>


</style>